import { useSelector } from 'react-redux';
import { PageStore } from 'modules/page/pageReducer';
import { MODULE_STATUS } from 'constants/modules';
import { Store } from 'types/Store';

export function usePage(): PageStore {
  return useSelector((state: Store) => state.page);
}

export function useIsPagesLoading(): boolean {
  const { hasLoaded, status } = usePage();

  return !hasLoaded && status !== MODULE_STATUS.Failed;
}

export function useShouldLoadPages(): boolean {
  const { hasLoaded, status } = usePage();

  return !hasLoaded && status !== MODULE_STATUS.Loading;
}
